import { Button, Popup } from 'common-components'

import * as Styled from './styled'
import { useAlertPopupsContext } from 'context/AlertPopups'
import { WARNING_POPUP_IMAGE_URL } from './consts'

const WarningPopup = () => {
  const {
    alertPopupsData: {
      warningPopup: {
        onClose,
        title,
        description,
        imageSrc = WARNING_POPUP_IMAGE_URL,
        buttons: {
          cancel: { label: cancelButtonLabel, onClick: onCancelBtnClick } = {},
          confirm: { label: confirmButtonLabel, onClick: onConfirmBtnClick }
        }
      }
    },
    resetAlertPopupsData
  } = useAlertPopupsContext()

  const _onCancelBtnClick = () => {
    onCancelBtnClick && onCancelBtnClick()
    resetAlertPopupsData()
  }

  const _onConfirmBtnClick = () => {
    onConfirmBtnClick && onConfirmBtnClick()
    resetAlertPopupsData()
  }

  const handleClose = () => {
    onClose && onClose()
    resetAlertPopupsData()
  }

  return (
    <Popup isOpen={!!title} onClose={handleClose} className="warning-popup">
      <Styled.Container>
        <Styled.Image src={imageSrc} alt="warning" />
        <Styled.ContentWrapper>
          <Styled.Title>{title}</Styled.Title>
          <Styled.Description>{description}</Styled.Description>
        </Styled.ContentWrapper>
        <Styled.ButtonsWrapper>
          {cancelButtonLabel ? (
            <Button type="secondary" onClick={_onCancelBtnClick}>
              {cancelButtonLabel}
            </Button>
          ) : null}
          {confirmButtonLabel ? (
            <Button type="primary" onClick={_onConfirmBtnClick}>
              {confirmButtonLabel}
            </Button>
          ) : null}
        </Styled.ButtonsWrapper>
      </Styled.Container>
    </Popup>
  )
}

export default WarningPopup
